<header style="box-shadow:none;" class="header headersearch sticky-header">
  <div class="container">
    <div class="d-flex">
      <div class="logo my-auto">
        <a [routerLink]="['/']">
          <img src="assets/images/logo-white.png" alt="logo" class="logo-white">
          <img src="assets/images/logo.png" alt="logo" class="logo-black" style="display: none;">
        </a>
      </div>
      <div class="main-navigation">
        <nav class="navbar navbar-expand-lg">
          <!-- Brand -->
          <a class="navbar-brand" href="javascript://"> </a>

          <!-- Toggler/collapsibe Button -->
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
            <span class="navbar-toggler-icon-new"></span>
            <span class="navbar-toggler-icon-new"></span>
            <span class="navbar-toggler-icon-new"></span>
          </button>

          <!-- Navbar links -->
          <div class="collapse navbar-collapse" id="collapsibleNavbar">
            <ul class="navbar-nav">
              <li><a [routerLink]="['/']" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                  Home </a></li>
              <!-- <li>
                <a [routerLinkActive]="['active']" [routerLinkActiveOptions]="{match:['/articles/']}" href="javascript://"
                   class="user-submenu-btn-new">Articles</a>
                <ul class="sub-menu">
                  <li class="user-name-list"><a [routerLink]="['/articles/yoga']" [routerLinkActive]="['active']"
                                                [routerLinkActiveOptions]="{exact:true}"> <img style="width: 30px;"
                                                                                               src="assets/images/yoga.jpeg">Yoga
                    for Life </a></li>
                  <li class="user-name-list"><a [routerLink]="['/articles/health']" [routerLinkActive]="['active']"
                                                [routerLinkActiveOptions]="{exact:true}"> <img style="width: 30px;"
                                                                                               src="assets/images/health.jpeg">Health
                  </a></li>
                </ul>

              </li> -->
              <li><a [routerLink]="['/articles']" [routerLinkActive]="['active']"
                  [routerLinkActiveOptions]="{exact:true}"> Articles </a></li>
              <li><a [routerLink]="['/doctors/list']" [routerLinkActive]="['active']"
                  [routerLinkActiveOptions]="{exact:true}"> Doctors </a></li>
              <li><a [routerLink]="['/hospitals/list']" [routerLinkActive]="['active']"
                  [routerLinkActiveOptions]="{exact:true}"> Hospitals </a></li>
              <li><a [routerLink]="['/pharmacy/list']" [routerLinkActive]="['active']"
                  [routerLinkActiveOptions]="{exact:true}"> Pharmacies </a></li>
              <li><a [routerLink]="['/labs/list']" [routerLinkActive]="['active']"
                  [routerLinkActiveOptions]="{exact:true}"> Labs </a></li>
              <li *ngIf="!isLoggedin"><a *ngIf="!isLoggedin" [routerLink]="null" (click)="loginUser()"
                  id="logintoggle_user" data-toggle="modal" data-target="#login-page_user"> Login </a></li>
              <li *ngIf="isLoggedin">
                <a class="user-submenu-btn-new"> <img width="40px" height="40px"
                    style="border:1px solid #000;border-radius:10px" [src]="loginData.profilePicture" alt="image"> </a>
                <ul class="sub-menu">
                  <li class="user-name"> Hi, {{ loginData.name ? loginData.name : 'User' }}</li>
                  <li class="user-name-list"><a [routerLink]="['/user-orders']"> <i class="fa fa-list-alt"
                        aria-hidden="true"></i> Order List
                    </a></li>
                  <li class="user-name-list"><a [routerLink]="['/telemedicine']"> <i class="fa fa-comment"
                        aria-hidden="true"></i> Tele Medicine
                    </a></li>

                  <li class="user-name-list"><a [routerLink]="['/notifications']"> <i class="fa fa-comment"
                        aria-hidden="true"></i> Notifications
                    </a></li>

                  <li class="user-name-list"><a [routerLink]="['/medical-history']"> <i class="fa fa-pencil-square-o"
                        aria-hidden="true"></i> Medical History </a></li>
                  <li class="user-name-list"><a [routerLink]="['/user-profile']"> <i class="fa fa-user"
                        aria-hidden="true"></i> View Profile </a></li>
                  <li class="user-name-list"><a [routerLink]="['/user-wallet']"> <i class="fa fa-money"
                        aria-hidden="true"></i> Wallet ({{ '₹ ' + loginData.wallet ? loginData.wallet : '0' }}) </a>
                  </li>
                  <li class="user-name-list"><a [routerLink]="['/user-plans']"> <i class="fa fa-tasks"
                        aria-hidden="true"></i> View Plans </a></li>
                  <li class="user-name-list"><a [routerLink]="" (click)="logout()"> <i class="fa fa-sign-out"
                        aria-hidden="true"></i> Logout
                    </a></li>
                </ul>
              </li>
              <li *ngIf="!partner"><a *ngIf="!isLoggedin" [routerLink]="['/partner']" id="logintoggle">
                  Partner </a></li>
              <li *ngIf="partner"><a *ngIf="!isLoggedin" [routerLink]="" id="logintoggle" data-toggle="modal"
                  data-target="#login-page">
                  Partner </a></li>

            </ul>
          </div>

          <div class="user-header-mob" [style.display]="showList ? 'block' : 'none'">
            <a *ngIf="isLoggedin" (click)="showList=!showList" [routerLink]="null" class="user-submenu-btn-new"> <img
                width="30px" height="30px" style="border:1px solid #000;border-radius:10px"
                [src]="loginData.profilePicture" alt="image"> </a>
            <ul [style.display]="showList ? 'block' : 'none'" class="sub-menu">
              <li class="user-name"> Hi, {{ loginData.name ? loginData.name : 'User' }}</li>
              <li class="user-name-list"><a [routerLink]="['/user-orders']"> <i class="fa fa-list-alt"
                    aria-hidden="true"></i> Order List
                </a></li>
              <li class="user-name-list"><a [routerLink]="['/telemedicine']"> <i class="fa fa-comment"
                    aria-hidden="true"></i> Tele Medicine
                </a></li>

              <li class="user-name-list"><a [routerLink]="['/notifications']"> <i class="fa fa-comment"
                    aria-hidden="true"></i> Notifications
                </a></li>

              <li class="user-name-list"><a [routerLink]="['/medical-history']"> <i class="fa fa-pencil-square-o"
                    aria-hidden="true"></i> Medical History </a></li>
              <li class="user-name-list"><a [routerLink]="['/user-profile']"> <i class="fa fa-user"
                    aria-hidden="true"></i> View Profile </a></li>
              <li class="user-name-list"><a [routerLink]="['/user-wallet']"> <i class="fa fa-money"
                    aria-hidden="true"></i> Wallet ({{ '₹ ' + loginData.wallet ? loginData.wallet : '0' }}) </a>
              </li>
              <li class="user-name-list"><a [routerLink]="['/user-plans']"> <i class="fa fa-tasks"
                    aria-hidden="true"></i> View Plans </a></li>
              <li class="user-name-list"><a [routerLink]="" (click)="logout()"> <i class="fa fa-sign-out"
                    aria-hidden="true"></i> Logout
                </a></li>
            </ul>
          </div>

        </nav>
      </div>
    </div>
  </div>
</header>
<!--- End of Header -->
<!-- The Modal  For PArtner -->
<div class="modal fade" id="login-page">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <!-- Modal body -->
      <div class="modal-body">
        <div class="sign-up-form login-form">
          <div id="login-screen" [ngStyle]="{'display': !loginhide ? 'block' : 'none' }">
            <h2 class="text-center"><span> Login </span> to Continue </h2>
            <form #f="ngForm" (ngSubmit)="EnterOtp(f)">
              <div class="row">
                <div class="col-md-12">
                  <div class="login-mob-img">
                    <img src="assets/images/loginscreen.jpeg" alt="image">
                  </div>
                </div>
                <div class="col-md-12">
                  <label> Enter Phone Number to Login1 </label>
                  <div class="form-group-main">
                    <input type="text" ng2TelInput (keypress)="numberOnly($event,null)"
                      [ng2TelInputOptions]="{initialCountry: 'in'}" minlength="10" maxlength="10"
                      #phoneNoPartner="ngModel" (countryChange)="onCountryChangePartner($event)" placeholder=""
                      [(ngModel)]="phoneNo" name="phoneNo" class="form-control" />
                    <!-- <input type="text" required minlength="10" maxlength="10" (keypress)="numberOnly($event,null)"
                           #phoneNoPartner="ngModel" class="form-control" [(ngModel)]="phoneNo" name="phoneNo"
                           placeholder=""> -->

                    <img src="assets/images/phone.png" alt="image">
                    <div *ngIf="phoneNoPartner.invalid && f.submitted" class="alert alert-danger">
                      <div *ngIf="f.submitted && phoneNoPartner.errors.required">Number is required</div>
                      <div *ngIf="f.submitted && phoneNoPartner.errors.minlength">Phone Number should be of 10 digits
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12" style="margin: 11px 0px -24px 0;">
                    <label style="display: block;"> Check One Option </label>
                    <div class="custom-control custom-checkbox custom-control-inline">
                      <input type="checkbox" value="Doctor" (change)="setVal('Doctor');type2='';type3='';type4=''"
                        [(ngModel)]="type1" class="custom-control-input" id="customCheck" name="example1">
                      <label class="custom-control-label" for="customCheck"> Doctor </label>
                    </div>
                    <div class="custom-control custom-checkbox custom-control-inline">
                      <input type="checkbox" value="Hospital" (change)="setVal('Hospital');type1='';type3='';type4=''"
                        [(ngModel)]="type2" class="custom-control-input" id="customCheck1" name="example2">
                      <label class="custom-control-label" for="customCheck1"> Hospital </label>
                    </div>
                    <div class="custom-control custom-checkbox custom-control-inline">
                      <input type="checkbox" value="Pharmecy" (change)="setVal('Pharmecy');type1='';type2='';type4=''"
                        [(ngModel)]="type3" class="custom-control-input" id="customCheck2" name="example3">
                      <label class="custom-control-label" for="customCheck2"> Pharmacy </label>
                    </div>
                    <div class="custom-control custom-checkbox custom-control-inline">
                      <input type="checkbox" value="Labs" (change)="setVal('Labs');type2='';type3='';type1=''"
                        [(ngModel)]="type4" class="custom-control-input" id="customCheck3" name="example4">
                      <label class="custom-control-label" for="customCheck3"> Lab </label>
                    </div>
                  </div>

                  <!-- <input type="radio" value="Doctor" name="type" [(ngModel)]="type" > Doctor
                  <input type="radio" value="Hospital" name="type" [(ngModel)]="type" > Hospital
                  <input type="radio" value="Pharmecy" name="type" [(ngModel)]="type" > Pharmacy
                  <input type="radio" value="Labs" name="type" [(ngModel)]="type" > Lab -->
                </div>
                <div class="col-md-12">
                  <input type="submit" value="Send OTP" class="btn-style" id="open-login-otp">
                  <div class="error" [ngStyle]="{ 'display': errorOtp ? 'block' : 'none', 'color':'red' }">
                    {{ errorOtpMessage }}
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div id="login-otp" [ngStyle]="{'display': showotp ? 'block' : 'none' }">
            <i class="fa fa-arrow-left" aria-hidden="true" (click)="showotp=false;loginhide=false"></i>
            <h2 class="text-center"><span> Verification Code </span></h2>
            <form>
              <div class="row">
                <div class="col-md-12">
                  <div class="login-mob-img">
                    <img src="assets/images/login-mob-img-otp.jpg" alt="image">
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="login-otp-recived">
                    <h5> Otp has been sent to <span> {{ phoneNo }} </span></h5>
                    <div class="otp-input-group">

                      <!-- <input *ngFor="let obj of otpValObjUser" type="text" maxlength="1" (keypress)="numberOnly($event,obj.arg)"  [name]="obj.name" [(ngModel)]="obj.model" [id]="obj.id" class="form-control"> -->
                      <input type="text" id="first" maxlength="1" (keydown)="numberOnlyBack($event,'first','next')"
                        (keypress)="numberOnly($event,'next')" name="otp2" [(ngModel)]="otpValObj1"
                        class="form-control">
                      <input type="text" (keydown)="numberOnlyBack($event,'first','next1')" maxlength="1"
                        (keypress)="numberOnly($event,'next1')" id="next" name="otp5" [(ngModel)]="otpValObj2"
                        class="form-control">
                      <input type="text" maxlength="1" (keydown)="numberOnlyBack($event,'next','next2')"
                        (keypress)="numberOnly($event,'next2')" id="next1" name="otp3" [(ngModel)]="otpValObj3"
                        class="form-control">
                      <input type="text" maxlength="1" (keydown)="numberOnlyBack($event,'next1','next2')"
                        (keypress)="numberOnly($event,null)" id="next2" name="otp4" [(ngModel)]="otpValObj4"
                        class="form-control">
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <input type="submit" value="Login" (click)="checkOtpfunc()" class="btn-style">
                  <div *ngIf="verifyOtpError" style="color:red">Otp does not match</div>
                  <div class="resend-otp">
                    <a [routerLink]="null" (click)="resendOtp()"> Resend OTP </a>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div id="login-pass" [ngStyle]="{'display': showpass ? 'block' : 'none' }">
            <i class="fa fa-arrow-left" (click)="showpass=false;loginhide=false" aria-hidden="true"></i>
            <h2 class="text-center"><span> Enter Password </span></h2>
            <form>
              <div class="row">

                <div class="col-md-12">
                  <div class="login-otp-recived">
                    <input [type]="showEye ? 'password' : 'text'" name="pass" [(ngModel)]="Pass" class="form-control">
                    <span [class]="showEye ? 'fa fa-fw fa-eye' : 'fa fa-fw fa-eye-slash'"
                      (click)="showEye=!showEye"></span>
                  </div>
                </div>
                <div class="col-md-12">
                  <input type="submit" value="Login" (click)="checkPassfunc()" class="btn-style">
                  <div *ngIf="verifyPassError" style="color:red">Password does not match</div>
                  <div class="resend-otp">
                    <a [routerLink]="null" (click)="forgotPass()"> Forgot Password? </a>
                  </div>
                </div>
              </div>
            </form>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<!-- The Modal  For PArtner -->
<div class="modal fade" id="login-page_user">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <!-- Modal body -->
      <div class="modal-body">
        <div class="sign-up-form login-form">
          <div id="login-screen_user" [ngStyle]="{'display': !showotp_user_login ? 'block' : 'none' }">
            <h2 class="text-center"><span> Login </span> to Continue </h2>
            <form>
              <div class="row">
                <div class="col-md-12">
                  <div class="login-mob-img">
                    <img src="assets/images/login-mob-img.jpg" alt="image">
                  </div>
                </div>
                <div class="col-md-12">
                  <label> Enter Phone Number to Login </label>
                  <div class="form-group-main">
                    <!-- <input type="text" style="width:50px" required (keypress)="numberOnly($event,null)" class="form-control mr-1"
                    [(ngModel)]="countryCode_user" name="countryCode_user" >
                    <input type="text" (keypress)="numberOnly($event,null)" class="form-control"
                           [(ngModel)]="phoneNo_user" name="phoneNo_user" placeholder="+91 9876543210"> -->
                    <input type="text" ng2TelInput [ng2TelInputOptions]="{initialCountry: 'in'}"
                      (hasError)="hasError($event)" minlength="10" maxlength="10"
                      (countryChange)="onCountryChange($event)" placeholder="" [(ngModel)]="phoneNo_user"
                      name="phoneNo_user" class="form-control" />
                    <img src="assets/images/phone.png" alt="image">
                    <p class="error" [ngStyle]="{ 'display': errorOtp_user ? 'block' : 'none', 'color':'red' }">
                      {{ errorOtpUserMessage }}</p>
                  </div>

                </div>
                <div class="col-md-12">
                  <input type="button" value="Send OTP" (click)="EnterOtp_user()" class="btn-style"
                    id="open-login-otp_user">
                  <!-- <div class="error" [ngStyle]="{ 'display': errorOtp_user ? 'block' : 'none', 'color':'red' }">There
                    was some error sending the OTP
                  </div> -->
                </div>
              </div>
            </form>
          </div>
          <div id="login-otp_user" [ngStyle]="{'display': showotp_user ? 'block' : 'none' }">
            <i class="fa fa-arrow-left" (click)="showotp_user=false;showotp_user_login=false" aria-hidden="true"></i>
            <h2 class="text-center"><span> Verification Code </span></h2>
            <form action="user.html">
              <div class="row">
                <div class="col-md-12">
                  <div class="login-mob-img">
                    <img src="assets/images/login-mob-img-otp.jpg" alt="image">
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="login-otp-recived">
                    <h5> Otp has been send to <span> {{ phoneNo_user }} </span></h5>
                    <div class="otp-input-group">
                      <input type="text" maxlength="1" (keydown)="numberOnlyBack($event,'first_user','next_user')"
                        (keypress)="numberOnly($event,'next_user')" id="first_user" name="otp2_user"
                        [(ngModel)]="otpValObjUser1" class="form-control">
                      <input type="text" maxlength="1" (keydown)="numberOnlyBack($event,'first_user','next1_user')"
                        (keypress)="numberOnly($event,'next1_user')" id="next_user" name="otp3_user"
                        [(ngModel)]="otpValObjUser2" class="form-control">
                      <input type="text" maxlength="1" (keydown)="numberOnlyBack($event,'next_user','next2_user')"
                        (keypress)="numberOnly($event,'next2_user')" id="next1_user" name="otp3_user"
                        [(ngModel)]="otpValObjUser3" class="form-control">
                      <input type="text" maxlength="1" (keydown)="numberOnlyBack($event,'next1_user','next2_user')"
                        (keypress)="numberOnly($event,null)" id="next2_user" name="otp5_user"
                        [(ngModel)]="otpValObjUser4" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <input type="submit" id="next_user_button" value="Login" (click)="checkOtpfunc_user()"
                    class="btn-style">
                  <div *ngIf="verifyOtpError_user" style="color:red">Otp does not match</div>
                  <div class="resend-otp">
                    <a [routerLink]="null" (click)="resendOtpUser()"> Resend OTP </a>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div id="login-pass_user" [ngStyle]="{'display': showpass_user ? 'block' : 'none' }">
            <i class="fa fa-arrow-left" (click)="showpass_user=false;showotp_user_login=false" aria-hidden="true"></i>
            <h2 class="text-center"><span> Enter Password </span></h2>
            <form>
              <div class="row">

                <div class="col-md-12">
                  <div class="login-otp-recived">
                    <input [type]="showEyeUser ? 'password' : 'text'" name="pass_user" [(ngModel)]="Pass_user"
                      class="form-control">
                    <span [class]="showEyeUser ? 'fa fa-fw fa-eye' : 'fa fa-fw fa-eye-slash'"
                      (click)="showEyeUser=!showEyeUser"></span>
                  </div>
                </div>
                <div class="col-md-12">
                  <input type="submit" value="Login" (click)="checkPassfunc_user()" class="btn-style">
                  <div *ngIf="verifyPassError_user" style="color:red">Password does not match</div>
                  <div class="resend-otp">
                    <a [routerLink]="null" (click)="forgotPassUser()"> Forgot Password? </a>
                  </div>
                </div>
              </div>
            </form>
          </div>


        </div>
      </div>
    </div>
  </div>
</div>

<app-resetpasswordpopup></app-resetpasswordpopup>